import React from 'react';

import Animation from './animation';
import Dialog from './dialog';
import Img from './img';

const Tile = ({ tile, currentDialog, setDialog, unsetDialog }) => {
    return (
        <div className='tiles__tile md:w-1/2'>
            { tile.offset && (<div className='hidden md:block' style={{ marginTop: tile.offset }} />) }
            <div className='relative'>
                <Img className='hidden md:block' filename={ tile.filename } />
                <Img className='md:hidden' filename={ tile.mobileFilename } />

                { tile.animations && (
                    tile.animations.map(animation => <Animation key={ animation.filename } animation={ animation } />)
                ) }

                { tile.dialogs && (
                    tile.dialogs.map((dialog, key) => (
                        <Dialog
                            key={ key }
                            dialog={ dialog }
                            currentDialog={ currentDialog }
                            setDialog={ setDialog }
                            unsetDialog={ unsetDialog }
                        />
                    ))
                ) }
            </div>
        </div>
    );
};

export default Tile;
